/*
 * @Author: Chao Yang
 * @Date: 2022-11-03 21:30:35
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-12-16 13:08:35
 */
import { Injectable } from "@angular/core";
import { DocumentViewerProxy } from "../../proxy/document-viewer/document-viewer.proxy";

@Injectable()
export class DocumentViewerService {
    /**
     *
     */
    constructor(private proxy: DocumentViewerProxy) {

    }

    postPages(id: number) {

        return this.proxy.postPages(id);
    }

    fetchExcelPrintImages(id: number) {
        return this.proxy.fetchExcelPrintImages(id);
    }

    postPagesForTrackRecord(link: string) {
        return this.proxy.postPagesForTrackRecord(link);
    }
}
